import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ThemeMode } from '../schemas/types/app-types';

interface ThemeState {
  mode: ThemeMode;
}

const initialState: ThemeState = {
  mode:
    (typeof window !== 'undefined' &&
      (localStorage.getItem('theme') as ThemeMode)) ||
    'light'
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: state => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', state.mode);
    },
    setTheme: (state, action: PayloadAction<ThemeMode>) => {
      state.mode = action.payload;
      localStorage.setItem('theme', action.payload);
    }
  }
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
